export default __webpack_public_path__ + "assets/images/prev-icon-87716317.svg";